module.exports = __webpack_public_path__ + "static/FuturaPT-Medium-995c64e152e8dc077222766889194951.woff";